import { useState, useEffect } from 'react';

interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  version: number;
}

export const useCookieManager = () => {
  const [showCookieDialog, setShowCookieDialog] = useState(false);
  const [cookiePreferences, setCookiePreferences] = useState<CookiePreferences | null>(null);

  // Cookie-Hilfsfunktionen
  const setCookie = (name: string, value: string, days: number) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict`;
  };

  const getCookie = (name: string): string => {
    const cookieName = name + "=";
    const cookies = document.cookie.split(';');
    for(let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return "";
  };

  // Cookie-Consent prüfen
  const checkCookieConsent = () => {
    const cookieConsent = getCookie("cookieConsent");
    
    if (!cookieConsent) {
      // Erster Besuch - Dialog anzeigen
      setShowCookieDialog(true);
      return;
    } 
    
    try {
      const preferences = JSON.parse(cookieConsent);
      setCookiePreferences(preferences);
      
      // Prüfen auf Version - falls sich die Cookie-Richtlinie geändert hat
      if (!preferences.version || preferences.version < 1) {
        setShowCookieDialog(true);
      }
      
    } catch (e) {
      // Fehler beim Parsen - Dialog zeigen
      console.error("Fehler beim Lesen der Cookie-Einstellungen:", e);
      setShowCookieDialog(true);
    }
  };

  // Cookie-Präferenzen speichern
  const savePreferences = (preferences: CookiePreferences) => {
    setCookie("cookieConsent", JSON.stringify(preferences), 365);
    setCookiePreferences(preferences);
    setShowCookieDialog(false);
  };

  // Dialog schließen
  const closeCookieDialog = () => {
    setShowCookieDialog(false);
  };

  // Beim Mount prüfen
  useEffect(() => {
    const checkConsent = () => {
      const cookieConsent = getCookie("cookieConsent");
      
      if (!cookieConsent) {
        setShowCookieDialog(true);
        return;
      } 
      
      try {
        const preferences = JSON.parse(cookieConsent);
        setCookiePreferences(preferences);
        
        if (!preferences.version || preferences.version < 1) {
          setShowCookieDialog(true);
        }
        
      } catch (e) {
        console.error("Fehler beim Lesen der Cookie-Einstellungen:", e);
        setShowCookieDialog(true);
      }
    };

    checkConsent();
  }, []);

  return {
    showCookieDialog,
    cookiePreferences,
    savePreferences,
    closeCookieDialog,
    checkCookieConsent
  };
};
